import styled from 'styled-components';

const StyledOrderDetailsModal = styled.div`
  .order-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
  }

  .order-item {
    padding: 8px;
    border-bottom: 1px solid #eee;
  }

  .order-link {
    color: var(--color-action-default);
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default StyledOrderDetailsModal;
